import { apiFetch } from './client';

export const submitForm = (type: string, data: Record<string, unknown>) =>
  apiFetch<{ success: boolean; message: string }>(`/api/forms/${type}`, {
    method: 'POST',
    body: JSON.stringify(data),
  });

export const subscribeEmail = (email: string) =>
  apiFetch<{ success: boolean; message: string }>('/api/subscribe', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
